import { render, staticRenderFns } from "./BetShareReceipt.vue?vue&type=template&id=227e3154&scoped=true"
import script from "./BetShareReceipt.vue?vue&type=script&lang=js"
export * from "./BetShareReceipt.vue?vue&type=script&lang=js"
import style0 from "./BetShareReceipt.vue?vue&type=style&index=0&id=227e3154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227e3154",
  null
  
)

export default component.exports